var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuestic-widget',{staticClass:"chart-widget",attrs:{"headerText":_vm.chartTitle}},[(_vm.chartData)?_c('vuestic-chart',{attrs:{"data":_vm.chartData,"type":"bubble"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }